import { render, staticRenderFns } from "./protected-router-link.vue?vue&type=template&id=ea605982&scoped=true&"
import script from "./protected-router-link.vue?vue&type=script&lang=js&"
export * from "./protected-router-link.vue?vue&type=script&lang=js&"
import style0 from "./protected-router-link.vue?vue&type=style&index=0&id=ea605982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea605982",
  null
  
)

export default component.exports